import { render } from "./OnlineConfirm.vue?vue&type=template&id=47e2819a&scoped=true&ts=true"
import script from "./OnlineConfirm.vue?vue&type=script&lang=ts"
export * from "./OnlineConfirm.vue?vue&type=script&lang=ts"

import "./OnlineConfirm.vue?vue&type=style&index=0&id=47e2819a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e2819a"]])

export default __exports__